/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { forwardRef } from "react";
import { NavLink } from "react-router-dom";

import { Badge, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useSidebar from "../../hooks/useSidebar";

const CustomRouterLink = forwardRef((props, ref) => (
  <React.Fragment ref={ref}>
    <NavLink {...props} />
  </React.Fragment>
));

const SidebarNavListItem = (props) => {
  const {
    title,
    href,
    depth = 0,
    children,
    icon,
    badge,
    redirect,
    open: openProp = false,
  } = props;

  const [open, setOpen] = React.useState(openProp);
  const { setIsOpen } = useSidebar();

  const handleToggle = () => {
    setOpen((state) => !state);
  };

  if (children) {
    return (
      <li className={`sidebar-item ${open ? "active" : ""}`}>
        <a
          className={`sidebar-link ${open ? "" : "collapsed"} ${
            redirect ? "redirect" : ""
          }`}
          data-bs-toggle="collapse"
          aria-expanded={open ? "true" : "false"}
          depth={depth}
          onClick={handleToggle}
        >
          {icon && <FontAwesomeIcon icon={icon} />}{" "}
          <span className="align-middle" depth={depth}>
            {title}
          </span>
          {badge && (
            <Badge className="badge-sidebar-primary" bg="" size={18}>
              {badge}
            </Badge>
          )}
          {open ? <div /> : <div />}
        </a>
        <Collapse in={open}>
          <ul className="sidebar-dropdown list-unstyled">{children}</ul>
        </Collapse>
      </li>
    );
  }

  return (
    <li
      className="sidebar-item"
      onClick={() => {
        if (redirect) window.open(redirect);
        else {
          setIsOpen((state) => !state);
          console.log("Here");
        }
      }}
    >
      <CustomRouterLink
        depth={depth}
        to={href}
        activeclassname={"active"}
        className={`sidebar-link ${redirect ? "redirect" : ""}`}
      >
        {icon && <FontAwesomeIcon icon={icon} />}
        <span className="align-middle" depth={depth}>
          {title}
        </span>
        {badge && (
          <Badge className="badge-sidebar-primary" bg="" size={18}>
            {badge}
          </Badge>
        )}
      </CustomRouterLink>
    </li>
  );
};

export default SidebarNavListItem;
